module.exports = __webpack_public_path__ + "img/ewm_gzh.9958f3d4.png";